<template>
  <div class="head m_clearLR m_tran50">
    <div class="head_box m_floatL" :class="currentIndex==0?'active':''" @click="select(0,'myCloud')" >
      <img :src="currentIndex==0?require('@/../public/images/myCloud_act.png'):require('@/../public/images/myCloud.png')" alt="">
      <p class="zhen_10" >{{_lang[$route.query.type].zhen_10}}</p>
     
    </div>
    <div class="head_box m_floatR" @click="select(1,'cloudTemplate')" :class="currentIndex==1?'active':''">
      <img  :src="currentIndex==1?require('@/../public/images/cloudTemplate_act.png'):require('@/../public/images/cloudTemplate.png')" alt="">
      <p class="zhen_11">{{_lang[$route.query.type].zhen_11}}</p>
    </div>
    <!-- <div class="head_box m_floatL" @click="select(2,'cloudShare')" :class="currentIndex==2?'active':''">
      <img src="@/../public/images/cloudShare.png" style="width:0.56rem" alt="">
      <p class="zhen_12">{{_lang[$route.query.type].zhen_12}}</p>
    </div> -->
  </div>
</template>

<script>
import {lang} from '@/utils/i18n'
export default {
  name: '',
  data(){
    return{
      currentIndex:0,
      _lang:[],
      // routeArr:[{
      //   img:'@/../public/images/myCloud.png',index:0,name:'11'
      // },{
      //   img:'@/../public/images/cloudTemplate.png',index:0,name:'22'
      // },{
      //   img:'@/../public/images/cloudShare.png',index:0,name:'33'
      // }]
    }
  },
  watch:{
    '$route.path':function(){
      if(this.$route.name=='cloudTemplate'){
      this.currentIndex = 1
    }else if(this.$route.name=='cloudShare'){
      this.currentIndex = 2
    }else{
      this.currentIndex = 0
    }
    }
  },
  created(){
    this._lang = lang
    if(this.$route.name=='cloudTemplate'){
      this.currentIndex = 1
    }else if(this.$route.name=='cloudShare'){
      this.currentIndex = 2
    }
  },
  methods:{
    select(index,path){
      window.scrollTo(0,0)
      if(this.$route.name == 'search'){
        this.$emit('searchType',path)
      }else{
        this.$router.push({name:path,query:this.$route.query})  
      }
      this.currentIndex = index
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.head{
  padding:0.35rem 1rem 0 1rem;
  .head_box{
    font-size:0.32rem;
    color:#333;
    width:1.8rem;
    text-align: center;
    text-align: center;
    border-bottom: 0.04rem solid #fff;
    padding: 0px 0.1rem;
    img{
      width:0.5rem;
      height:0.5rem;
    }
    p{
      height:0.64rem;
      line-height: 0.64rem;
    }
    &.active p{
      color:#0497ff;
    }
  }
  .head_box.active{
    border-bottom: 0.04rem solid #0497ff;
    
  }
  div.head_box:nth-child(2){
    margin:0 .15rem;
  }
}
</style>
